<template>
  <v-row class="fill-height">
    <v-col cols="12">
      <gg-card class="align-items-center text-center fill-height">
        <gg-card-text v-if="status === 'Pending'">
          <b>Your service is pending. Please check back soon.</b>
        </gg-card-text>
        <v-card-text v-if="status === 'Suspended'">
          <b>Your service is suspended. Please contact Support.</b>
        </v-card-text>
      </gg-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'HostingPending',
  props: {
    status: {
      type: String,
      required: true
    }
  }
}
</script>
